import { FunctionComponent, useEffect, useState } from "react"
import React from "react"
import { Col, Row, Space, Spin } from "antd"
import { Broker } from "../components/broker"
import { BrokerDto, BrokersService } from "../api"

interface BrokersPageProps {
}

const BrokersPage: FunctionComponent<BrokersPageProps> = (props) => {
  const [loading, setLoading] = useState<boolean>(true)
  const [brokers, setBrokers] = useState<BrokerDto[]>([])

  const fetchBrokers = async () => {
    setLoading(true)
    try {
      const response = await BrokersService.getBrokers()
      setBrokers(response.brokers)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchBrokers()
  }, [])

  if (loading) {
    return <>
      <h2>Brokers</h2>
      <Space>
        <Spin />
      </Space>
    </>
  }
  
  return <>
    <h2>Brokers</h2>
    <Row gutter={[16, 16]}>
      {
        brokers.length === 0 ? <p>No broker</p> : null
      }
      {
        brokers?.map(broker => <Col><Broker broker={broker} /></Col>)
      }
    </Row>
  </>
}

export { BrokersPage }